import 'presentation/assets/fonts/fonts.css';
import React from 'react';
import {createRoot} from 'react-dom/client';
import {RecoilRoot} from 'recoil';
import {HelmetProvider} from 'react-helmet-async';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {datadogRum} from '@datadog/browser-rum';
import {Router} from 'main/routes/router';
import {ThemeType} from 'presentation/themes';
import {ptBR} from 'date-fns/locale';
import {QueryClientProvider} from '@tanstack/react-query';
import {queryClient} from 'infra/libs/react-query';
import {Plugins} from './plugins';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');

const root = createRoot(container);

datadogRum.init({
	applicationId: '9a736492-4ed8-4852-8ecb-16a3507b507d',
	clientToken: 'pub96c72a5f4160e029c1fd477f33cbdee4',
	// `site` refers to the Datadog site parameter of your organization
	// see https://docs.datadoghq.com/getting_started/site/
	site: 'datadoghq.com',
	service: 'portal-beneficiario',
	env: process.env.DD_ENVIRONMENT,
	// Specify a version number to identify the deployed version of your application in Datadog
	// version: '1.0.0',
	sessionSampleRate: 100,
	sessionReplaySampleRate: 0,
	traceSampleRate: 20,
	trackUserInteractions: true,
	trackResources: true,
	trackLongTasks: true,
	defaultPrivacyLevel: 'mask-user-input',
	allowedTracingUrls: [
		'https://api-dev.hapvida.com.br',
		'https://api-hml.hapvida.com.br',
		'https://api.hapvida.com.br',
		'https://api-lab.hapvida.com.br',
	],
});

root.render(
	<HelmetProvider>
		<ThemeType>
			<QueryClientProvider client={queryClient}>
				<RecoilRoot>
					<LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
						<Router />
					</LocalizationProvider>
					<Plugins />
				</RecoilRoot>
			</QueryClientProvider>
		</ThemeType>
	</HelmetProvider>,
);
